import GlobalStyle from './globalStyles.js';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home.js';
import AtlasPage from './pages/Atlas.js';
import CoexpPage from './pages/Coexp.js';

function App() {
  return (
    <>
    <GlobalStyle/>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/atlas" element={<AtlasPage/>} />
        <Route path="/coexp" element={<CoexpPage/>} />
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
